import * as types from './ReceivableActionTypes';
import ReceivableApi from './ReceivableApi';
import { DateType } from './Types';

function getInitialDataSuccess(result: any) {
    return { type: types.GET_INITIAL_DATA_SUCCESS, result: result };
}

export function getInitialData() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        ReceivableApi.getInitialData().then((result: any) => {
            dispatch(getInitialDataSuccess(result));
        });
}

function getDataSuccess(result: any) {
    return { type: types.GET_DATA_SUCCESS, result: result };
}

export function getData(
    legalEntityId: number,
    fromDate: any,
    toDate: any,
    onlyUnsettledInvoices: boolean,
    customer: number
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        ReceivableApi.getData(
            legalEntityId,
            fromDate,
            toDate,
            onlyUnsettledInvoices,
            customer
        ).then((result: any) => {
            dispatch(getDataSuccess(result));
        });
}

export function resetState(): any {
    return (dispatch: (result: any) => void) => dispatch({ type: types.STATE_RESET });
}

export function resetLegalEntityState(legalEntityId: number): any {
    return (dispatch: (result: any) => void) =>
        dispatch({
            type: types.LEGAL_ENTITY_STATE_RESET,
            result: legalEntityId
        });
}
